import { renderSlot as _renderSlot, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, withModifiers as _withModifiers, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "reference" }
const _hoisted_2 = { class: "section-title" }
const _hoisted_3 = {
  key: 1,
  class: "section-title"
}

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_Icon = _resolveComponent("Icon")
  const _component_Tooltip = _resolveComponent("Tooltip")
  const _component_Command = _resolveComponent("Command")
  const _component_Divider = _resolveComponent("Divider")
  const _component_ScrollBar = _resolveComponent("ScrollBar")
  const _component_el_dropdown_menu = _resolveComponent("el-dropdown-menu")
  const _component_el_dropdown = _resolveComponent("el-dropdown")

  return (_openBlock(), _createBlock(_component_el_dropdown, {
    ref: "dropdown",
    class: _normalizeClass(["caps-menu", {disabled: $props.disabled, pointer: !$props.disabled}]),
    placement: "top-start",
    trigger: "click",
    persistent: false,
    disabled: $props.disabled,
    teleported: false,
    "popper-class": "chats-dropdown-edit",
    onVisibleChange: _cache[0] || (_cache[0] = $event => ($data.visible = $event)),
    onClick: _cache[1] || (_cache[1] = _withModifiers(() => {}, ["stop"]))
  }, {
    dropdown: _withCtx(() => [
      _createVNode(_component_el_dropdown_menu, { class: "items-menu" }, {
        default: _withCtx(() => [
          _createVNode(_component_ScrollBar, {
            "max-height": "42dvh",
            class: "scrollbar",
            fade: ""
          }, {
            default: _withCtx(() => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($options.skill_groups, (group) => {
                return (_openBlock(), _createElementBlock(_Fragment, {
                  key: group.category
                }, [
                  _createElementVNode("div", _hoisted_2, _toDisplayString(group.title), 1 /* TEXT */),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(group.items, (skill) => {
                    return (_openBlock(), _createBlock(_component_Command, {
                      key: skill.command,
                      item: skill,
                      onClick: $event => ($options.selectSkill(skill.command))
                    }, null, 8 /* PROPS */, ["item", "onClick"]))
                  }), 128 /* KEYED_FRAGMENT */))
                ], 64 /* STABLE_FRAGMENT */))
              }), 128 /* KEYED_FRAGMENT */)),
              ($props.skills.length && $props.sources.length)
                ? (_openBlock(), _createBlock(_component_Divider, {
                    key: 0,
                    m: "0.8rem"
                  }))
                : _createCommentVNode("v-if", true),
              ($props.sources.length)
                ? (_openBlock(), _createElementBlock("div", _hoisted_3, "Sources"))
                : _createCommentVNode("v-if", true),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($props.sources, (source) => {
                return (_openBlock(), _createBlock(_component_Command, {
                  key: source.command,
                  item: source,
                  onClick: $event => ($options.selectSource(source.command))
                }, null, 8 /* PROPS */, ["item", "onClick"]))
              }), 128 /* KEYED_FRAGMENT */))
            ]),
            _: 1 /* STABLE */
          })
        ]),
        _: 1 /* STABLE */
      })
    ]),
    default: _withCtx(() => [
      _renderSlot(_ctx.$slots, "reference", { visible: $data.visible }, () => [
        _createElementVNode("div", _hoisted_1, [
          ($data.visible)
            ? (_openBlock(), _createBlock(_component_Icon, {
                key: 0,
                icon: "scroll-text",
                stroke: "var(--gray-500)",
                size: "1.6rem",
                "stroke-width": "1",
                hover: ""
              }))
            : (_openBlock(), _createBlock(_component_Tooltip, {
                key: 1,
                text: "Skills & Sources",
                teleported: ""
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_Icon, {
                    hoverable: "",
                    icon: "scroll-text",
                    stroke: "var(--gray-500)",
                    size: "1.6rem",
                    "stroke-width": "1"
                  })
                ]),
                _: 1 /* STABLE */
              }))
        ])
      ], true)
    ]),
    _: 3 /* FORWARDED */
  }, 8 /* PROPS */, ["class", "disabled"]))
}